function Page404() {
  return null;
}

export default Page404;
